export default "__VITE_ASSET__es5uDs_i__"